module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOpen) ? _c('better-modal', {
    attrs: {
      "closable": true,
      "id": _vm.id,
      "tabbedModal": true,
      "showFooter": false
    },
    on: {
      "close-modal": _vm.trackEvent,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.trackEvent.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header",
      "id": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modalTitle)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modalSubtitle)
    }
  })]), _c('div', {
    staticClass: "tabbed-modal-body",
    attrs: {
      "slot": "body",
      "id": "body"
    },
    slot: "body"
  }, [_vm._t("default", null, {
    "tabs": "tabs"
  }), _c('vue-tabs', {
    ref: "tabRouter",
    attrs: {
      "id": "tabbed-modal",
      "direction": "vertical"
    },
    on: {
      "tab-change": _vm.handleTabChange
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return (_vm.verifyTabAuthorization(tab.idFunctionalitie)) ? _c('v-tab', {
      key: tab.idTabRoot,
      ref: tab.tabRef,
      refInFor: true,
      staticClass: "tab",
      attrs: {
        "id": tab.idTabRoot,
        "title": tab.idTabRoot
      }
    }, [_c('div', {
      staticClass: "tab-left",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('i', {
      class: tab.icon
    }), _c('span', {
      staticClass: "title title_center",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    })]), _c(tab.type, _vm._b({
      tag: "component",
      attrs: {
        "id": tab.idTabContent
      }
    }, 'component', tab.props, false))], 1) : _vm._e()
  }), 1)], 2)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44a5b89a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44a5b89a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/gridDetailsModal.pug
// module id = 1406
// module chunks = 0